/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import errorToast from "helpers/errorToast";
import { ReactComponent as CopyToClipboardIcon } from "assets/images/iconsV2/copy.svg";
import { ReactComponent as SuccessIcon } from "assets/images/iconsV2/check-circle-green.svg";

interface IClipboardProps {
  text: string;
  copyOnly: boolean;
  children?: React.ReactNode;
  copyIconPosition?: "left" | "right";
}

const CopyToClipboard = function ({ text, copyOnly, children, copyIconPosition = "right" }: IClipboardProps) {
  const [isCopied, setIsCopied] = useState<Boolean>(false);
  const [isHover, setIsHover] = useState<Boolean>(false);

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 5000);
      })
      .catch((err) => errorToast(err, "Could not copy to clipboard."));
  };

  if ("clipboard" in navigator) {
    if (copyOnly) {
      return (
        <div
          role="button"
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          onClick={handleCopyClick}
          className="cursor-pointer d-flex"
          tabIndex={0}
        >
          <span>{children}</span>

          <OverlayTrigger placement="top" overlay={<Tooltip id="">{isCopied ? "Copied!" : "Click to copy"}</Tooltip>}>
            <span className="clipboard-icon copy-text">
              {isHover && isCopied ? <SuccessIcon /> : isHover && !isCopied && <CopyToClipboardIcon />}
            </span>
          </OverlayTrigger>
        </div>
      );
    }
    return (
      <div
        className="mb-0 align-copy-icon"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onClick={handleCopyClick}
      >
        <span className="d-flex flex-row align-items-center mb-0">
          {copyIconPosition === "right" && (
            <>
              <span className="">{text}</span>
              <OverlayTrigger placement="top" overlay={<Tooltip id="">{isCopied ? "Copied!" : "Click to copy"}</Tooltip>}>
                {isHover ? (
                  <span className="clipboard-icon icon-tooltip ">
                    {isCopied ? (
                      <SuccessIcon className="position-absolute" style={{ top: -7 }} />
                    ) : (
                      !isCopied && <CopyToClipboardIcon className="position-absolute" style={{ top: -7 }} />
                    )}
                  </span>
                ) : (
                  <></>
                )}
              </OverlayTrigger>
            </>
          )}
          {copyIconPosition === "left" && (
            <>
              <OverlayTrigger placement="top" overlay={<Tooltip id="">{isCopied ? "Copied!" : "Click to copy"}</Tooltip>}>
                {isHover ? (
                  <span className="clipboard-icon icon-tooltip ">
                    {isCopied ? (
                      <SuccessIcon className="position-absolute" style={{ top: -7 }} />
                    ) : (
                      !isCopied && <CopyToClipboardIcon className="position-absolute" style={{ top: -7 }} />
                    )}
                  </span>
                ) : (
                  <></>
                )}
              </OverlayTrigger>
              <span className="">{text}</span>
            </>
          )}
        </span>
      </div>
    );
  }

  return <p className="mb-0">{text}</p>;
};

CopyToClipboard.propTypes = {
  text: PropTypes.string,
  copyOnly: PropTypes.bool,
  children: PropTypes.node,
};

CopyToClipboard.defaultProps = {
  copyOnly: false,
  children: null,
  text: "",
  copyIconPosition: "right",
};

export default CopyToClipboard;
